export default __webpack_public_path__ + "static/media/hero.4462eb53.jpg";